// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"577":"6217969c","968":"8f67568b"}[chunkId] + ".chunk.css";
};